import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { UserAccountInfo } from 'src/app/models/user-account/account-data';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { LoadingService } from 'src/app/shared/loading/loading.service';

@Component({
  selector: 'app-income-report-info-dialog',
  templateUrl: './income-report-info-dialog.component.html',
  styleUrls: ['./income-report-info-dialog.component.scss']
})
export class IncomeReportInfoDialogComponent {
  account: UserAccountInfo;
  subscription: Subscription = new Subscription();
  operationSuccess: boolean | null = null;
  errorCode: string | null = null;
  constructor(
    public dialogRef: MatDialogRef<IncomeReportInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loadingService: LoadingService,
    private settingsService: SettingsService,
  ) {
    this.account = data.account;
  }

  getButtonTextIR(): string {
    return "Baixar IR " + moment().subtract(1, 'year').year().toString();
  }

  getOperationStatus(): boolean | null {
    return this.operationSuccess;
  }

  getDocumentType(): string {
    return this.account?.type == 'PJ' ? 'CNPJ' : 'CPF';
  }

  getDocumentExample(): string {
    return this.account?.type == 'PJ' ? '12.345.678/0001-95' : '123.456.789-00';
  }

  getOperationMessage(): string {
    return this.getOperationStatus() ? 'Informe de rendimentos baixado com sucesso.' : `Não foi possível baixar informe de rendimentos.\n${this.getMessageFromErrorCode(this.errorCode)}`;
  }

  getMessageFromErrorCode(errorCode: string | null): string {
    switch (errorCode) {
      case 'CBE446':
      case 'CBE447':
        return 'Informe de rendimentos indisponível para o ano solicitado.'
      default:
        return 'Verifique suas permissões e tente novamente mais tarde.'
    }
  }

  isLoading(): boolean {
    return this.loadingService.isLoading();
  }

  downloadIR() {
      this.loadingService.initializeLoading();
      this.subscription.add(this.settingsService.getIncomeReports(
          moment().subtract(1, 'year').year().toString(), 
          this.account?.accountIndex,
      ).subscribe(
          (result) => {
              if(this.account?.type == 'PF') {
                  const linkSource = 'data:application/pdf;base64,' + result.body.incomeFile;
                  this._downloadFile(linkSource);
              } else if (this.account?.type == 'PJ') {
                  Object.keys(result).forEach(key => {
                      const quarter = key.slice(-1);
                      const linkSource = 'data:application/pdf;base64,' + result[key].incomeFile;
                      this._downloadFile(linkSource, Number(quarter));
                    });
              }
              this.operationSuccess = true;
              this.loadingService.finalizeLoading();
          },
          (error) => {
              this.operationSuccess = false;
              this.errorCode = error.error.errorCode;
              this.loadingService.finalizeLoading();
          }
      ))
    }

    _downloadFile(linkSource: string, quarter?: number) {
      const downloadLink = document.createElement("a");
      const fileName = "informe-rendimentos-" + (moment().year() - 1) + (quarter ? `-T${quarter}` : '') + ".pdf";
  
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }


}
